<template>
    <div class="page-container">
        <div class="page-title">填写补款数据</div>
        <!-- 表单部分 -->
        <div class="form-block">
            <div class="input-grp">
                <div class="input-title">本次补款总金额 
                    <!-- <span class="title-notice">{{userInfo.level == 3 ? '(补款金额需高于36000元)' : '(补款金额需高于17970元)'}}</span> -->
                </div>
                <input type="number" v-model="amount" placeholder="请输入补款金额">
            </div>
            <div class="input-grp" @click="showDatePicker = true">
                <div class="input-title">转账日期</div>
                <div class="input-box" v-if="date">{{date}}</div>
                <div class="input-box" v-else style="color:#999;">请选择转账日期</div>
            </div>
            <div class="input-grp">
                <div class="input-title">上传转账凭证 <span>(请上传本次补货的所有转账凭证)</span></div>
                <div class="file-list">
                    <van-uploader v-model="fileList" result-type="file" :after-read="afterRead" />
                </div>
            </div>
            <div class="btn-normal" @click="confirm">确认补款</div>
        </div>
        <!-- 补款须知 -->
        <div class="page-section">
            <div class="section-title">补款须知</div>
            <div class="notice-list">
                <div class="notice-item red">1、补款后首次进货享受相应退货政策即失效,所有商品非质量问题不予退货</div>
                <div class="notice-item">2、往公户转账后,财务将在1-2个工作日审核完毕,若有问题请联系客服</div>
            </div>
        </div>
        <div class="page-section">
            <div class="section-title">请往以下公户转账</div>
            <div class="account-block">
                <div class="account-item">
                    <span class="account-title">账户名称</span>
                    <span class="account-content" :style="{fontSize:fontSize + 'vw'}">{{accountInfo.name}}</span>
                    <span class="btn-copy" v-clipboard:copy="accountInfo.name" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                </div>
                <div class="account-item">
                    <span class="account-title">开户行</span>
                    <span class="account-content">{{accountInfo.bankName}}</span>
                    <span class="btn-copy" v-clipboard:copy="accountInfo.bankName" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                </div>
                <div class="account-item">
                    <span class="account-title">对公账户号</span>
                    <span class="account-content">{{accountInfo.account}}</span>
                    <span class="btn-copy" v-clipboard:copy="accountInfo.account" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                </div>
            </div>
        </div>
        <van-overlay
            :show="showDatePicker"
            @click="showDatePicker = false"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="请选择日期"
                @confirm="choiceDate"
                @cancel="showDatePicker = false"
                @click.stop
            />
        </van-overlay>
    </div>
</template>
<script>
import { Uploader,Notify,Toast,DatetimePicker,Overlay } from 'vant'
import $http from '@/lib/request'
import config from '@/config'
import { getLocalUserInfo } from '@/lib/util'
import ResizeText from 'vue-resize-text'

export default {
    data() {
        return {
            fileList: [],
            accountInfo:{
                name:'',
                bankName:'',
                account:''
            },
            fileUrlList:[],
            amount:'',
            date:'',
            showDatePicker:false,
            userInfo:{},
            currentDate:new Date(),
            fontSize:0,
        }
    },
    directives:{
        ResizeText
    },
    activated(){
        this.userInfo=getLocalUserInfo();
        $http({
            method:'post',
            url:config.api.replenishmentInfo
        }).then(res=>{
            if(res.errno == 0){
                this.accountInfo=res.data;
                //适配账户文字超过一行自动变小
                if(this.accountInfo.name.length * 3.733 > 50.666){
                    this.fontSize=50.666 / this.accountInfo.name.length - 0.4;
                }else{
                    this.fontSize=3.733;
                }
            }else{
                Toast(res.errmsg);
            }
        })
    },
    deactivated(){
        this.fileList= [];
        this.accountInfo={
            name:'',
            bankName:'',
            account:''
        };
        this.fileUrlList=[];
        this.amount='';
        this.date='';
        this.showDatePicker=false;
    },
    components:{
        [Uploader.name]:Uploader,
        [Notify.name]:Notify,
        [Toast.name]:Toast,
        [DatetimePicker.name]:DatetimePicker,
        [Overlay.name]:Overlay
    },
    methods:{
        copySucc(){
            Notify({ type: 'success', message: '复制成功' });
        },
        copyFail(){
            Notify({ type: 'danger', message: '复制失败' });
        },
        afterRead(file){
            let data=new FormData();
            data.append('file',file.file);
            
            $http({
                method:'post',
                data:data,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                url:config.api.picUpload
            }).then(res=>{
                if(res.errno == 0){
                    let list=this.fileList;
                    //清除vant在fileList中多生成的无效数据
                    for(let i=0;i<list.length;i++){
                        if(list[i].file){
                            list.splice(i,1)
                        }
                    }

                    this.fileList.push({
                        url:res.data.url
                    }),
                    this.fileUrlList.push(res.data.url);
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        confirm(){
            // if(this.userInfo.level == 2 && this.amount < 17970){
            //     Toast('最低补款金额为17970元');
            //     return;
            // }
            // if(this.userInfo.level == 3 && this.amount < 36000){
            //     Toast('最低补款金额为36000元');
            //     return;
            // }
            if(this.fileList.length == 0){
                Toast('请上传转账凭证');
                return;
            }
            $http({
                method:'post',
                data:{
                    amount:this.amount,
                    date:this.date,
                    url:this.fileUrlList.join(',')
                },
                url:config.api.confirmBk
            }).then(res=>{
                if(res.errno == 0){
                    Toast('申请成功，财务审核入账中');
                    setTimeout(()=>{
                        this.$router.push({
                            name:'account-overview'
                        });
                    },2000);
                    // this.$router.push({
                    //     name:'replenishment-detail',
                    //     params:{
                    //         orderId:res.data.orderId
                    //     }
                    // });
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        choiceDate(value){
            this.date=`${value.getFullYear()}-${value.getMonth()+1}-${value.getDate()}`;
            this.showDatePicker = false;
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-uploader__preview-image{
                width:96px;
                height:96px;
            }
::v-deep .van-uploader__upload{
    width:96px;
    height:96px;
}
::v-deep .van-picker{
    position: fixed;
    left:0;
    bottom:0;
    width:100%;
}
.page-container{
    min-height: calc(100vh - 46px);
    background:#f5f5f5;
    box-sizing: border-box;
    padding:10px;
    padding-top: 15px;
    .page-title{
        color:#333;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 10px;
    }
    .form-block{
        background:#fff;
        border-radius: 4px;
        padding:20px;
        .input-grp{
            margin-bottom: 15px;
            .input-title{
                font-size: 14px;
                color:#333;
                line-height: 20px;
                margin-bottom: 5px;
                &>span{
                    color:#999;
                    font-size: 12px;
                }
            }
            &>input{
                display: block;
                width:100%;
                line-height: 38px;
                box-sizing: border-box;
                padding:0 16px;
                background:#f5f5f5;
                border-radius: 4px;
                border:none;
                font-size: 14px;
            }
            .input-box{
                width:100%;
                line-height: 38px;
                box-sizing: border-box;
                padding:0 16px;
                background:#f5f5f5;
                border-radius: 4px;
                border:none;
                font-size: 14px;
            }
            .file-list{
                margin-bottom: 30px;
            }
        }
        .btn-normal{
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            border-radius: 26px;
            color:#fff;
            font-size: 16px;
            margin:0 auto;
        }
    }
    .page-section{
        background:#fff;
        border-radius: 4px;
        padding:20px;
        margin-top: 10px;
        .section-title{
            font-size: 14px;
            color:#333;
            line-height: 20px;
            margin-bottom: 14px;
        }
        .notice-list{
            .notice-item{
                margin-bottom: 10px;
                font-size: 12px;
                line-height: 18px;
                color:#666;
                &.red{
                    color:#E43D3D;
                }
            }
        }
        .account-block{
            .account-item{
                margin-bottom: 12px;
                color:#333;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                font-size: 14px;
                .account-title{
                    width:80px;
                    margin-right: 6px;
                }
                .account-content{
                    max-width:190px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    margin-right: 30px;
                }
                .btn-copy{
                    color:#3088F5;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>